import { GetterTree } from 'vuex';
import { RootState } from '../../types';
import { StoreState } from './types';

export const getters: GetterTree<StoreState, RootState> = {
  screenClusters: (state: StoreState) => {
    return state.screenClusters;
  },
};
